module.exports = __webpack_public_path__ + "a0d37ceabe9ca8372daccecd993b9a6d.png";